import { createFileRoute, Outlet } from "@tanstack/react-router";

import { OrganizationSettingsPage } from "~/components/settings/organization-settings-page";

// V4.1: Layout route with Outlet for child modal routes
export const Route = createFileRoute("/_authenticated/settings/organization")({
  component: OrganizationLayout,
});

function OrganizationLayout() {
  return (
    <>
      <OrganizationSettingsPage />
      {/* V4.1: Outlet for child routes (invite, change-role, remove modals) */}
      <Outlet />
    </>
  );
}
